'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeStates = exports.getStorage = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.default = storageMiddleware;

var _config = require('config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPayload = function getPayload(_ref) {
  var content = _ref.content,
      data = _ref.data,
      pages = _ref.pages,
      site = _ref.site,
      user = _ref.user;
  return (0, _stringify2.default)({
    content: content,
    data: data,
    pages: pages,
    site: site,
    user: user
  });
};

var getStorage = exports.getStorage = function getStorage() {
  try {
    return JSON.parse(sessionStorage.getItem(_config.STORE_KEY)) || {};
  } catch (e) {
    return {};
  }
};

var mergeStates = exports.mergeStates = function mergeStates() {
  var clientState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var serverState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return (0, _extends3.default)({}, clientState, serverState, {

    // for pages, we want to merge the client and server states.
    // the server will have the currently requested page, and
    // everything else will be served from the browser.
    pages: (0, _extends3.default)({}, clientState.pages, serverState.pages),

    // for user, only the client matters
    user: clientState.user
  });
};

function storageMiddleware(_ref2) {
  var getState = _ref2.getState;

  return function (next) {
    return function (action) {
      var nextAction = next(action);

      if (_config.CLIENT && window && window.sessionStorage) {
        var payload = getPayload(getState());
        sessionStorage.setItem(_config.STORE_KEY, payload);
      }

      return nextAction;
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/middlewares/storage.js
// module id = 450
// module chunks = 0